import React from "react";
import {
  Container,
  Grid,
  Box,
  Typography,
  Paper,
  Card,
  CardMedia,
  useTheme,
} from "@mui/material";

const AreaGroupComponent = ({ title, description, image }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={2}
      sx={{
        p: 4,
        my: 4,
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Grid container spacing={4}>
        {image && (
          <Grid item xs={12} md={4}>
            <Card sx={{ height: "100%", borderRadius: 2, overflow: "hidden" }}>
              <CardMedia
                component="img"
                image={image || "/api/placeholder/600/400"}
                alt={title}
                sx={{
                  width: "100%",
                  height: "100%",
                  minHeight: "250px",
                  objectFit: "contain",
                }}
              />
            </Card>
          </Grid>
        )}

        <Grid item xs={12} md={image ? 8 : 12}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#C10E14",
            }}
          >
            {title}
          </Typography>

          <Typography variant="body1" sx={{ color: "text.secondary" }}>
            {description}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

// Example usage
const AreaGroupDisplay = ({ developerData }) => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: 8,
        mb: 4,
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <AreaGroupComponent
        title={developerData?.title}
        description={developerData?.description}
        image={developerData?.image}
      />
    </Container>
  );
};

export default AreaGroupDisplay;
